import { render, staticRenderFns } from "./ComplainRate.vue?vue&type=template&id=5dd71a8e"
import script from "./ComplainRate.vue?vue&type=script&lang=ts"
export * from "./ComplainRate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports